// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2ylc8","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1lOw0"};